import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';

import { FormModule } from 'shared/form/form.module';
import { SharedModule } from 'shared/shared.module';

import { WelcomeComponent } from './welcome.component';
import { WelcomeRoutingModule } from './welcome-routing.module';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    WelcomeRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    FormModule,
  ],
  declarations: [WelcomeComponent],
  exports: [WelcomeComponent]
})
export class WelcomeModule {}
